/**
 * src/api/config.js
 *
 * Purpose: app-wide runtime configuration for the Navixy API v2 backbone
 * (the equivalent of the deployed pro-ui minified module "8514" whose export
 * `a()` returned `{ websockets, apiUrl, ... }`, plus the un-minified
 * `pro-ui/Config.js` anchor).
 *
 * Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
 * (apiRoot, cookie key names, appRedirect, urls), internal impl re-authored.
 */

// VERBATIM from pro-ui/Config.js -> apiProfiles.japi.apiRoot
const API_ROOT = '//api.lacak.io';

// request() posts to `CONFIG.apiUrl + endpoint`, where `endpoint` is a bare
// action string like "user/auth" -> so apiUrl carries the trailing slash.
const API_URL = API_ROOT + '/';

const CONFIG = {
  // --- API v2 (japi profile) ---
  apiRoot: API_ROOT,
  apiUrl: API_URL,

  // --- realtime ---
  // VERBATIM Config.websockets = true; the socket engine reads this to decide
  // websocket vs HTTP-poll transport.
  websockets: true,

  // VERBATIM Config.mapApi
  mapApi: 'leaflet',

  // --- session <-> classic-app bridge (VERBATIM Config.appRedirect) ---
  appRedirect: {
    authProperty: 'session_key',
    appPage: '.',
    loginPage: (typeof window !== 'undefined' && window.location
      ? window.location.origin
      : '') + '/#/login'
  },

  // --- cookie / storage key names (VERBATIM Config.cookies) ---
  cookies: {
    key: {
      _default: 'session_key', // the session cookie
      external: 'hash'         // the name it travels under on every API call
    },
    service: 'dService'        // dealer/service marker cookie
  },

  // --- classic-app page routes (VERBATIM Config.urls) ---
  urls: {
    login_target: '../pro',
    auth: 'login',
    recover: 'login/recover',
    activate: 'login/activate'
  },

  // user/get_info re-poll cadence (VERBATIM 6e4 ms in loadUser)
  userInfoPollInterval: 60000
};

// Mirrors module "8514" export `a()` — a function returning the live config.
export function getConfig() {
  return CONFIG;
}

export const apiUrl = CONFIG.apiUrl;
export const apiRoot = CONFIG.apiRoot;

export default CONFIG;
